"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_env_1 = require("@snapchat/web-env");
const web_slugify_url_1 = require("@snapchat/web-slugify-url");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const react_intl_1 = require("react-intl");
const web_i18n_1 = require("@snapchat/web-i18n");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const SEARCH_BASE_URL = (0, web_env_1.isSecproxyDomain)()
    ? "https://web-search.mesh.sc-corp.net"
    : process.env.NEXT_PUBLIC_SEARCH_BASE_URL || "https://www.snapchat.com/explore";
/**
 * SearchBar component to route users to /search/[query].
 */
function SearchBar({ pageType, expandOnFocus, localeProps, messagesProps, searchQuery, }) {
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)();
    const logSearchAction = (0, react_1.useCallback)(async () => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType: pageType ? pageType : web_blizzard_reporting_1.PageType.SEARCH,
            actionName: web_blizzard_reporting_1.WebActionName.SearchClick,
            webClientId: webClientId ?? "",
        });
        void (0, web_graphene_reporting_1.incrementCounter)("SearchBar.Search.Click");
        await graphene_1.default.flush();
    }, [pageType, webClientId]);
    const search = (0, react_1.useCallback)((query) => {
        // don't allow empty searches
        if (!query) {
            void (0, web_graphene_reporting_1.incrementCounter)("SearchBar.Search.EmptyQuery");
            return;
        }
        const slug = (0, web_slugify_url_1.toSlugUrl)(query);
        void logSearchAction();
        const windowObj = (0, web_env_1.getWindow)();
        if (windowObj) {
            windowObj.location.href = `${SEARCH_BASE_URL}/${slug}`;
        }
    }, [logSearchAction]);
    const { locale, messages } = (0, web_i18n_1.useLocale)({
        defaultLocale: localeProps,
        defaultMessages: messagesProps,
        loadMessages: web_core_ui_1.loadMessages,
    });
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, messages: messages, defaultLocale: web_i18n_1.Locale.enUS, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.SearchInput, { expandOnFocus: expandOnFocus, onSearch: search, currentSearchQuery: searchQuery }) }));
}
exports.SearchBar = SearchBar;
//# sourceMappingURL=SearchBar.js.map